import { hasFeatureFlag } from 'utils/flagsmith';
import { MASTER as MASTER_ROLE } from 'constants/roles';

export const isMasterUser = (user) => {
  const enableMasterPassword = hasFeatureFlag('master-user-auth0');
  return enableMasterPassword && user && user.role && user.role === MASTER_ROLE;
};
